<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        @click="openAdd()"
        >添加</el-button
      >
      <!-- <el-button type="danger" size="mini"  @click="open"
        >删除</el-button
      > -->
      <el-button
        type="success"
        size="mini"
        
        @click="getList"
        >刷新</el-button
      >
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        
        style="margin-left: 10px"
        @click="select()"
        >筛选</el-button
      >
    </div>
    <div class="head_search">
      <div class="item_warp">
        <label style="margin: 0 10px;">乙方名称</label>
        <el-input
          v-model="name"
          placeholder="请输入乙方名称"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px;">账号</label>
        <el-input
          v-model="username"
          placeholder="请输入账号"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px;">备注</label>
        <el-input
          v-model="memo"
          placeholder="请输入备注"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="tableData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 1661px"
      size="mini"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50"/>
      <el-table-column prop="address" label="操作" width="100">
        <template slot-scope="scope">
          <el-button
            type="primary"
            class="edit-button"
            size="mini"
            
            @click="edit(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
      <el-table-column prop="name" label="乙方名称" width="100" />
      <el-table-column prop="username" label="账号" width="100" />
      <el-table-column prop="address" label="是否启用" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.isEnabled" style="color:#06CC00">启用</div>
          <div v-if="!scope.row.isEnabled" style="color:red">禁用</div>
        </template>
      </el-table-column>
      <el-table-column prop="memo" label="备注" width="100" />
      <el-table-column prop="telegram" label="专属Telegram" width="150" />
      <el-table-column prop="whatsApp" label="专属WhatsApp" width="150" />
      <el-table-column prop="messenger" label="专属Messenger" width="150" />
      <el-table-column prop="indexMidPath" label="首页社交平台群组外链" width="170" />
      <el-table-column prop="createDate" label="创建时间" width="170" />
      
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getList"
    />

    <!-- 添加弹窗 -->
    
    <el-dialog
      :visible.sync="dialogVisible"
      width="1000px"
      title="编辑"
      :before-close="editClose"
      :close-on-click-modal="false"
    >
      <!-- 编辑用户表格 -->
      <el-form ref="editForm" :model="editForm" label-width="120px">
        <el-form-item label="乙方名称">
          <el-input v-model="active.name" placeholder="请输入乙方名称" />
        </el-form-item>
        <el-form-item label="账号" prop="count">
          <el-input v-model="active.username" placeholder="请输入账号"/>
        </el-form-item>
        <el-form-item label="密码" prop="count">
          <el-input v-model="active.password" placeholder="请输入密码"/>
        </el-form-item>
        <el-form-item label="设置" prop="count">
          <el-checkbox v-model="isEnabled">是否启用</el-checkbox>
        </el-form-item>
        <el-form-item label="备注" prop="count">
          <el-input v-model="active.memo" placeholder="请输入备注"/>
        </el-form-item>

        <el-form-item label="专属Telegram">
          <el-input v-model="active.telegram" placeholder="请输入专属Telegram" />
          <el-checkbox style="margin-left: 20px;" v-model="isTelegram">是否显示</el-checkbox>
        </el-form-item>
        <el-form-item label="专属WhatsApp">
          <el-input v-model="active.whatsApp" placeholder="请输入专属WhatsApp" />
          <el-checkbox style="margin-left: 20px;" v-model="isWhatsApp">是否显示</el-checkbox>
        </el-form-item>
        <el-form-item label="专属Messenger">
          <el-input v-model="active.messenger" placeholder="请输入专属Messenger" />
          <el-checkbox style="margin-left: 20px;" v-model="isMessenger">是否显示</el-checkbox>
        </el-form-item>
        <!-- <el-form-item label="发帖客服链接">
          <el-input v-model="active.postCustomer" placeholder="请输入发帖客服链接" />
        </el-form-item> -->
        <el-form-item label="首页社交平台群组外链">
          <el-input v-model="active.indexMidPath" placeholder="请输入首页社交平台群组外链" />
        </el-form-item>
       
        <el-form-item>
          <el-popconfirm title="确定添加？" @confirm="addManagement()">
          <el-button
            slot="reference"
            type="primary"
            class="edit-button"
          >添加</el-button>
        </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 添加用户弹窗 -->
    <el-dialog
      :visible.sync="edit_dialogVisible"
      width="1000px"
      title="编辑"
      :before-close="editClose"
      :close-on-click-modal="false"
    >
      <!-- 编辑用户表格 -->
      <el-form ref="editForm" :model="editForm" label-width="120px">
        <el-form-item label="乙方名称">
          <el-input v-model="editForm.name" placeholder="请输入乙方名称" />
        </el-form-item>
        <el-form-item label="账号" prop="count">
          <el-input v-model="editForm.username" placeholder="请输入账号"/>
        </el-form-item>
        <el-form-item label="密码" prop="count">
          <el-input v-model="editForm.password" placeholder="请输入密码"/>
          <span style="color:red;margin-left: 10px;">留空表示不修改</span>
        </el-form-item>
        <el-form-item label="设置" prop="count">
          <el-checkbox v-model="editForm.isEnabled">是否启用</el-checkbox>
        </el-form-item>
        <el-form-item label="备注" prop="count">
          <el-input v-model="editForm.memo" placeholder="请输入备注"/>
        </el-form-item>

        <el-form-item label="专属Telegram">
          <el-input v-model="editForm.telegram" placeholder="请输入专属Telegram" />
          <el-checkbox style="margin-left: 20px;" v-model="editForm.isTelegram">是否显示</el-checkbox>
        </el-form-item>
        <el-form-item label="专属WhatsApp">
          <el-input v-model="editForm.whatsApp" placeholder="请输入专属WhatsApp" />
          <el-checkbox style="margin-left: 20px;" v-model="editForm.isWhatsApp">是否显示</el-checkbox>
        </el-form-item>
        <el-form-item label="专属Messenger">
          <el-input v-model="editForm.messenger" placeholder="请输入专属Messenger" />
          <el-checkbox style="margin-left: 20px;" v-model="editForm.isMessenger">是否显示</el-checkbox>
        </el-form-item>
        <!-- <el-form-item label="发帖客服链接">
          <el-input v-model="editForm.postCustomer" placeholder="请输入发帖客服链接" />
        </el-form-item> -->
        <el-form-item label="首页社交平台群组外链">
          <el-input v-model="editForm.indexMidPath" placeholder="请输入首页社交平台群组外链" />
        </el-form-item>
        <el-form-item>
          <el-popconfirm title="确定添加？" @confirm="editManagement()">
          <el-button
            slot="reference"
            type="primary"
            class="edit-button"
          >更新</el-button>
        </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密

export default {
  name: "Management",
  components: { Pagination,VueUeditorWrap },
  data() {
    return {
      option: "", // 初始选项
      options: [], // 选择角色
      name: "", // 搜索的管理员名称
      tableData: [], // 展示的表单信息
      // 添加表单
      active: {},
      // 修改表单
      editForm: { },
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      multipleSelection: [], // 选中项s
      dialogVisible: false, // 添加弹窗
      dialog: false, // 添加弹窗
      edit_dialogVisible: false, // 编辑弹窗
      Isedit: false, // 是否是编辑弹窗
      loading: false, // 表格加
      buttongLoding: false, // 按钮加载
      name:'',
      username:'',
      memo:'',
      isEnabled:false,
      isChat:false,
      isTelegram:false,
      isWhatsApp:false,
      isMessenger:false,
      isLinkUrl:false,
      isTelegramGroup:false,
      isAd:false,
      isSignJump:false,
      isStartJump:false
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 筛选
    select() {
      this.pageNum = 1;
      this.getList();
    },
    // 获取表单信息
    getList() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
        name:this.name,
        username:this.username,
        memo:this.memo
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
      this.$api.operate
        .yiFangList(params)
        .then((res) => {
          this.tableData = res.records;
          this.total = res.total;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 关闭添加弹窗
    handleClose() {
      this.$refs.active.resetFields();
    },
    // 关闭修改弹窗
    editClose(done) {
      this.editInfo = {};
      done();
    },
    // 删除选中项
    handleDel() {
      var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.operate
        .message2Delete(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
    },
    // 打开新增弹窗
    openAdd() {
      this.dialogVisible = true;
      this.isEnabled =  false
      this.isTelegram =  false
      this.isWhatsApp =  false
      this.isMessenger =  false
      this.isLinkUrl =  false
      this.isTelegramGroup =  false
      this.isAd =  false
      this.isSignJump =  false
      this.isStartJump =  false
      
    },
    // 打开编辑弹窗
    edit(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.edit_dialogVisible = true;
    },
    // 添加用户
    addManagement() {
          this.active.isEnabled =  this.isEnabled
          this.active.isTelegram =  this.isTelegram
          this.active.isWhatsApp =  this.isWhatsApp
          this.active.isMessenger =  this.isMessenger
          this.active.isLinkUrl =  this.isLinkUrl
          this.active.isTelegramGroup =  this.isTelegramGroup
          this.active.isAd =  this.isAd
          this.active.isSignJump =  this.isSignJump
          this.active.isStartJump =  this.isStartJump
          this.$api.operate
            .yiFangSave(this.active)
            .then((res) => {
              this.$message.success(res);
              this.dialogVisible = false;
              this.getList();
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
            .finally(() => {
              this.buttongLoding = false;
            });
    },
    // 更新用户信息
    editManagement() {
      this.$api.operate
        .yiFangUpdate(this.editForm)
        .then((res) => {
          this.$message.success(res);
          this.getList();
          this.edit_dialogVisible = false;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.buttongLoding = false;
        });
    },
    // 打开删除弹窗
    open() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleDel();
        })
        .catch(() => {
          
        });
    },
   
  },
};
</script>
<style lang="scss" scoped>
.role_warp {
  width: 100%;
  overflow: hidden;
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
::v-deep .el-input__inner{
  padding: 0 8px !important;
}
</style>
